import { HelpCenter } from '@/components/help/help-center.js';
import { EDISON_GUIDE_CONFIG } from '@edison/help';

export function HelpPage() {
  return (
    <HelpCenter
      novaProjectId=""
      guides={EDISON_GUIDE_CONFIG}
    />
  );
}
